import { Stack } from "@mui/material";
import ComplianceAlertBox from "../../../../components/ComplianceAlertBox";
import ComplianceAlertMessage from "../../../../components/ComplianceAlertMessage";
import { Compliance } from "../../../../types";

export const ComplianceWrapper = (props: { compliance?: Partial<Compliance> }) => {
  const { compliance } = props;

  return (
    <Stack direction="row" alignItems="center" justifyContent="center" padding={2} sx={{mt: 2, mb: 2}}>
      <Stack direction="row" alignItems="flex-start">
        <Stack>
          <Stack direction="row" spacing={1}>
            <ComplianceAlertBox compliance_status={compliance?.compliance_status ?? 4} data-testid="compliance-alert-box"></ComplianceAlertBox>
            <ComplianceAlertMessage compliance_status={compliance?.compliance_status ?? 4} message={compliance?.message_long ?? ''} data-testid="compliance-alert-message"></ComplianceAlertMessage>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
};